import { Person } from "../api/person";
import styled, { OverHeading, px } from "livemap-ui";
import { NavLink } from "react-router-dom";

export interface UserInfoProps {
  user: Person;
}

type Props = UserInfoProps;

export function UserInfo({ user }: Props) {
  return (
    <>
      <TitleSection>
        <RegistrationDate>
          {new Date(user.registeredAt).toLocaleDateString()}
        </RegistrationDate>
        <NameTitle>
          {user.firstName} {user.lastName}
        </NameTitle>
      </TitleSection>

      <Section>
        <OverHeading>Your E-mail</OverHeading>
        <p>{user.email}</p>
      </Section>

      <Section>
        <OverHeading>Your cell phone</OverHeading>
        <p>
          +{user.dialingCode} {user.cellPhone}
        </p>
      </Section>

      <TitleSection>
        <p>What to do next:</p>
        <NavLink to="/sign-in">Sign in to your account</NavLink>
      </TitleSection>
    </>
  );
}

const TitleSection = styled.div`
  text-align: center;
  margin: ${px(12, 0, 24, 0)};
  padding: ${px(24, 0)};
  border-top: 1px solid ${(p) => p.theme.borderColor};
  border-bottom: 1px solid ${(p) => p.theme.borderColor};

  &:last-child {
    border-bottom: 0;
    padding-bottom: 0;
  }
`;

const NameTitle = styled.h1`
  font-size: ${px(20)};
`;

const RegistrationDate = styled.time`
  display: block;
  font-family: ${(p) => p.theme.headingFontFamily};
  font-weight: 500;
  opacity: ${(p) => p.theme.disabledOpacity};
  font-size: ${px(14)};
  text-transform: uppercase;
`;

const Section = styled.div`
  margin-top: ${px(24)};
`;
